module.exports = __webpack_public_path__ + "static/img/5.1cbb548.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/word/5.png
// module id = 1t8t
// module chunks = 1